import { observer } from "mobx-react";
import React from "react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";

type Props = {
	placeholder: string | undefined;
	rows: number;
	cols: number;
	textId: string;
};


@observer
class TextAreaField extends React.Component<Props> {

	textareaHandler = (e: any) => {
		store.productConfigurationStore?.textHandler(e.target.value, this.props.textId);
	};

	render() {
		const textInputValue = store.productConfigurationStore?.selection.textNotes[this.props.textId]

		return (
			<>
				<div className="textarea-wrapper">
					<textarea
						className="form-control message"
						rows={this.props.rows}
						cols={this.props.cols}
						placeholder={this.props.placeholder}
						value={textInputValue}
						onChange={this.textareaHandler}
					></textarea>
				</div>
			</>
		);
	}
}

export default TextAreaField;
